(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0a35"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0a35"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kI8SP", function(module, exports) {

$parcel$export(module.exports, "register", () => $f13ecebb1f16f955$export$6503ec6e8aabbaf, (v) => $f13ecebb1f16f955$export$6503ec6e8aabbaf = v);
var $f13ecebb1f16f955$export$6503ec6e8aabbaf;
var $f13ecebb1f16f955$export$f7ad0328861e2f03;
"use strict";
var $f13ecebb1f16f955$var$mapping = new Map();
function $f13ecebb1f16f955$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f13ecebb1f16f955$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f13ecebb1f16f955$var$resolve(id) {
    var resolved = $f13ecebb1f16f955$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f13ecebb1f16f955$export$6503ec6e8aabbaf = $f13ecebb1f16f955$var$register;
$f13ecebb1f16f955$export$f7ad0328861e2f03 = $f13ecebb1f16f955$var$resolve;

});

parcelRegister("hIarR", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $ce4ea6902f7a0721$export$bdfd709ae4826697, (v) => $ce4ea6902f7a0721$export$bdfd709ae4826697 = v);
var $ce4ea6902f7a0721$export$bdfd709ae4826697;
var $ce4ea6902f7a0721$export$c9e73fbda7da57b6;
var $ce4ea6902f7a0721$export$5a759dc7a1cfb72a;
"use strict";
var $ce4ea6902f7a0721$var$bundleURL = {};
function $ce4ea6902f7a0721$var$getBundleURLCached(id) {
    var value = $ce4ea6902f7a0721$var$bundleURL[id];
    if (!value) {
        value = $ce4ea6902f7a0721$var$getBundleURL();
        $ce4ea6902f7a0721$var$bundleURL[id] = value;
    }
    return value;
}
function $ce4ea6902f7a0721$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ce4ea6902f7a0721$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $ce4ea6902f7a0721$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $ce4ea6902f7a0721$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$ce4ea6902f7a0721$export$bdfd709ae4826697 = $ce4ea6902f7a0721$var$getBundleURLCached;
$ce4ea6902f7a0721$export$c9e73fbda7da57b6 = $ce4ea6902f7a0721$var$getBaseURL;
$ce4ea6902f7a0721$export$5a759dc7a1cfb72a = $ce4ea6902f7a0721$var$getOrigin;

});

var $a45086c440a6e5d5$exports = {};


(parcelRequire("kI8SP")).register((parcelRequire("hIarR")).getBundleURL("4qPut"), JSON.parse('["4qPut","controller.js","8hKV5","symbol-defs.9d9fd998.svg"]'));

class $ab33a4389d496521$var$BrandHover {
    // #parentElement = document.querySelector(".brands-2-wrapper");
    #brandLogos = document.querySelectorAll(`.brand-logo img`);
    constructor(){
        this.addHandlerHover();
    }
    addHandlerHover() {
        [
            "mouseenter",
            "mouseleave"
        ].forEach((ev)=>this.#brandLogos.forEach((logo)=>{
                logo.addEventListener(ev, function() {
                    this.classList.toggle("gray-filter");
                });
            }));
    }
}
var $ab33a4389d496521$export$2e2bcd8739ae039 = new $ab33a4389d496521$var$BrandHover();


class $f182f04d9e8b81a7$var$FAQ {
    // #QandAs = document.querySelectorAll(`#faqs-2 .question`);
    #parentElement = document.querySelector(".faqs-2-questions");
    constructor(){
        this.addHandlerQuestions();
    }
    addHandlerQuestions() {
        //  guard close is for when user is not in homepage
        if (!this.#parentElement) return;
        this.#parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".question");
            const minusIcon = btn.querySelector(".fa-minus").closest("span");
            const plusIcon = btn.querySelector(".fa-plus").closest("span");
            if (!btn) return;
            if (btn.ariaExpanded === "false") {
                plusIcon.classList.remove("d-none");
                minusIcon.classList.add("d-none");
            } else {
                plusIcon.classList.add("d-none");
                minusIcon.classList.remove("d-none");
            }
        });
    }
}
var $f182f04d9e8b81a7$export$2e2bcd8739ae039 = new $f182f04d9e8b81a7$var$FAQ();


class $b936f479e4f933e2$var$ChangeSliders {
    circles = document.querySelectorAll(".circle");
    itemContainer = document.querySelectorAll(".item-container");
    #parentElement = document.querySelector("#features");
    activeNum = 0;
    interval;
    removeActiveCircle() {
        this.circles[this.activeNum].classList.remove("active-circle");
        this.itemContainer.forEach((item)=>{
            item.classList.add("d-none");
        });
    }
    addActiveCircle() {
        this.circles[this.activeNum].classList.add("active-circle");
        this.itemContainer[this.activeNum].classList.toggle("d-none");
    }
    changeActiveCircle(num) {
        // 1) remove all active circles
        this.removeActiveCircle();
        // 2) set activeNum in manuall or auto situation
        // when user click on circle
        if (num) this.activeNum = num - 1;
        else // in observer situation
        this.activeNum = this.activeNum >= 0 && this.activeNum < this.itemContainer.length - 1 ? ++this.activeNum : this.activeNum = 0;
        // 3) chose active circle with help of activNum
        this.addActiveCircle();
    }
    addHandlerManualSlider(handler) {
        window.addEventListener("click", (e)=>{
            const btn = e.target.closest(".circle");
            if (!btn) return;
            const goToSlide = +btn.dataset.cirnum;
            handler(goToSlide);
        });
    }
    addHandlerAutoSlider() {
        //  guard close is for when user is not in homepage
        if (!this.#parentElement) return;
        const observer = new IntersectionObserver((entries, _)=>{
            const [entry] = entries;
            if (entry.isIntersecting) this.interval = setInterval(this.changeActiveCircle.bind(this), 2000);
            if (!entry.isIntersecting) clearInterval(this.interval);
        }, {
            root: null,
            threshold: 0.5
        });
        observer.observe(this.#parentElement);
    }
}
var $b936f479e4f933e2$export$2e2bcd8739ae039 = new $b936f479e4f933e2$var$ChangeSliders();


class $c3602668100fbfee$var$autoCalendarDate {
    miladiDate = document.querySelectorAll(".miladi");
    miladiYearDOM = document.querySelector(".miladiY");
    weekDay = document.querySelectorAll("#week-day");
    miliSecondDay = 86400000;
    firstLeapYearshamsi = 1399;
    daysPassedResult;
    // prettier-ignore
    shamsiMonthArr = [
        "farvardin",
        "ordibehesht",
        "khordad",
        "tir",
        "mordad",
        "shahrivar",
        "mehr",
        "aban",
        "azar",
        "dey",
        "bahman",
        "esfand"
    ];
    // prettier-ignore
    shamsiMonthObj = {
        "farvardin": 31,
        "ordibehesht": 31,
        "khordad": 31,
        "tir": 31,
        "mordad": 31,
        "shahrivar": 31,
        "mehr": 30,
        "aban": 30,
        "azar": 30,
        "dey": 30,
        "bahman": 30,
        "esfand": this.isLeapYear(this.shamsiCurrentYear, this.firstLeapYearshamsi) ? 30 : 29
    };
    miladiYear = this.shamsiMonthArr.indexOf(this.slug()) >= this.shamsiMonthArr.indexOf("dey") ? +this.shamsiCurrentYear() + 622 : +this.shamsiCurrentYear() + 621;
    isLeapYear(currentYear, firstleapYear) {
        return (currentYear - firstleapYear) % 4 === 0;
    }
    constructor(){
        if (!this.shamsiMonthArr.includes(this.slug())) return;
        this.daysPassedResult = this.daysPassed(this.slug());
        this.renderMiladiDate();
        this.renderWeekday();
    }
    shamsiCurrentYear() {
        return new Intl.DateTimeFormat("en-US", {
            calendar: "persian",
            year: "numeric"
        }).format(new Date()).split(" ")[0];
    }
    slug() {
        return window.location.pathname.split("").filter((item)=>item !== "/").join("");
    }
    CountFromDate() {
        return this.isLeapYear(this.shamsiCurrentYear, this.firstLeapYearshamsi) ? `${+this.shamsiCurrentYear() + 621}-03-20` : `${+this.shamsiCurrentYear() + 621}-03-21`;
    }
    daysPassed(month) {
        let arrIndex = this.shamsiMonthArr.indexOf(month);
        let daysPassed = this.shamsiMonthArr.filter((item, i)=>i < arrIndex).reduce((acc, item)=>acc + this.shamsiMonthObj[item], 0) * this.miliSecondDay;
        return daysPassed;
    }
    renderMiladiDate() {
        // 1) this part is for miladi days
        this.miladiDate.forEach((day, i, arr)=>day.textContent = new Date(+new Date(this.CountFromDate()) + this.daysPassedResult + (i - 1) * this.miliSecondDay).getDate());
        // 2) this part is for miladi year
        this.miladiYearDOM.textContent = `(${this.miladiYear})`;
    }
    renderWeekday() {
        this.weekDay.forEach((day, i)=>day.textContent = new Intl.DateTimeFormat("fa-IR", {
                calendar: "persian",
                weekday: "long"
            }).format(+new Date(this.CountFromDate()) + this.daysPassedResult + (i - 1) * this.miliSecondDay));
    }
}
var $c3602668100fbfee$export$2e2bcd8739ae039 = new $c3602668100fbfee$var$autoCalendarDate();


var $46594bafc6aec9e6$exports = {};

$46594bafc6aec9e6$exports = (parcelRequire("hIarR")).getBundleURL("4qPut") + "symbol-defs.9d9fd998.svg";


class $7444704d607188f2$var$search {
    parentEl = document.querySelector(".search__overlay");
    searchInput = document.querySelector("#search");
    resultMess;
    resultNum;
    searchMessage = document.querySelector(".search__message");
    spinnerCon = document.querySelector(".search__message--spinner");
    resultHtml = document.querySelector(".search__result-con");
    searchField = document.querySelector(".search__field ");
    phoneHeader = document.querySelector(".wsmobileheader");
    excludeKeys = [
        "ArrowRight",
        "ArrowUp",
        "ArrowLeft",
        "ArrowDown",
        "Enter"
    ];
    deafultMessage = `
  <h2 class="search__text--before text-center">
      \u{646}\u{62A}\u{627}\u{6CC}\u{62C} \u{62C}\u{633}\u{62A}\u{62C}\u{648}
      <svg class="search__icon">
          <use href="${0, (/*@__PURE__*/$parcel$interopDefault($46594bafc6aec9e6$exports))}#icon-search"></use>
      </svg>
  </h2>`;
    successMessage = `
  <h2 class="search__text--after text-center">
    <div class="search__message-">
        <span class="search__result-num">0</span> \u{645}\u{648}\u{631}\u{62F} \u{628}\u{631}\u{627}\u{6CC} <span class="search__result-text"> ' \u{6A9}\u{644}\u{645}\u{647} \u{633}\u{631}\u{686} \u{634}\u{62F}\u{647} ' </span> \u{6CC}\u{627}\u{641}\u{62A} \u{634}\u{62F}
    </div>
  </h2>`;
    failMessage = `
  <h2 class="search__text--before text-center">
    \u{645}\u{648}\u{631}\u{62F}\u{6CC} \u{6CC}\u{627}\u{641}\u{62A} \u{646}\u{634}\u{62F} \u{2639}\u{FE0F}
  </h2>`;
    errorMessage = `
  <h2 class="search__text--before text-center">
    \u{645}\u{634}\u{6A9}\u{644}\u{6CC} \u{62F}\u{631} \u{62C}\u{633}\u{62A}\u{62C}\u{648} \u{67E}\u{6CC}\u{634} \u{622}\u{645}\u{62F}\u{647}\u{2639}\u{FE0F}
  </h2>`;
    constructor(){
        if (!this.parentEl) return;
        this.addHandlerOverlayOpen();
        this.addHandlerOverlayClose();
        // for prevent form submit when user press enter
        this.addHandlerSubmit();
    }
    /**
   * @abstract this methode makes search overlay open or close
   * @param {string} atrrBol - aria-expanded situation
   * @param {string} overflowSitu - makes overflow of body hide or scroll
   */ overlayToggler(atrrBol, overflowSitu) {
        // make aria-expanded flase or true
        this.parentEl.setAttribute("aria-expanded", atrrBol);
        //shows or hides search overlay
        this.parentEl.classList.toggle("search__overlayOpen");
        //render deafult message in field
        this.renderMessage(this.deafultMessage);
        // this makes background scroll enable/disable
        document.querySelector("body").style.overflow = overflowSitu;
        //
        this.clear();
        this.searchInput.value = "";
        this.spinnerCon.classList.add("d-none");
        // in phone view makes menu visible/invisible
        this.phoneHeader.classList.toggle("d-none");
    }
    addHandlerOverlayOpen() {
        window.addEventListener("click", (function(e) {
            // when user on browser window clicks on search btn
            const btn = e.target.closest(".search__btn");
            // if user dose not click on search btn return
            if (!btn) return;
            //make search overlay visible and set aria-expanded to true
            this.overlayToggler("true", "hidden");
            // fo auto focus on search bar
            setTimeout(()=>{
                this.searchInput.focus();
            }, 200);
        }).bind(this));
    }
    addHandlerOverlayClose() {
        // 1) when user press escape btn
        window.addEventListener("keyup", (function(e) {
            e.preventDefault();
            if (this.parentEl.ariaExpanded === "false") return;
            const btn = e.key;
            if (btn === "Escape") this.overlayToggler("false", "scroll");
        }).bind(this));
        // 2) when user click outside field
        this.parentEl.addEventListener("click", (function(e) {
            const btn = !e.target.closest(".search__field") && !e.target.closest(".search__input--text");
            if (!btn) return;
            this.overlayToggler("false", "scroll");
        }).bind(this));
        // 3) when user clicks on x icon
        window.addEventListener("click", (function(e) {
            const btn = e.target.closest(".search__icon-background");
            if (!btn) return;
            this.overlayToggler("false", "scroll");
        }).bind(this));
    }
    clear() {
        this.resultHtml.innerHTML = "";
    }
    generateMarkup(data) {
        return data.map((postObj, i, arr)=>{
            return `
          <div class="search__result-box">
                <div class="search__result-img">
                    <img src=${postObj.featureImg} alt="">
                </div>

                <div class="search__result-des">
                   <a href="${postObj.permalink}">
                       <h5 class="search__result-title">${postObj.title}</h5>
                   </a>

                  <sub class="search__ath"> ${postObj.author}</sub>
                </div>
          </div>
        `;
        }).join("");
    }
    render(data) {
        this.spinnerCon.classList.add("d-none");
        // 1) when user deletes search input, dont render anything
        if (!this.searchInput.value.length) // this.searchMessage.classList.remove("d-none");
        return this.renderMessage(this.deafultMessage);
        // 2) if search keyword does not have result
        if (!data.length) {
            // clear search result
            this.clear();
            // render fail message (return is for not countinuing nex step)
            return this.renderMessage(this.failMessage);
        }
        //if search keyword have result
        this.clear();
        this.resultHtml.insertAdjacentHTML("beforeend", this.successMessage);
        this.resultNum = document.querySelector(".search__result-num");
        this.resultMess = document.querySelector(".search__result-text");
        this.resultMess.style.color = "red";
        this.resultHtml.insertAdjacentHTML("beforeend", this.generateMarkup(data));
        this.resultNum.textContent = data.length;
        this.resultMess.textContent = `' ${this.searchInput.value} '`;
    }
    renderSpinner() {
        // this.resultHtml.innerHTML = '<span class="loader"></span>';
        this.spinnerCon.classList.remove("d-none");
        this.spinnerCon.innerHTML = '<span class="loader"></span>';
    }
    renderMessage(message) {
        this.searchMessage.classList.remove("d-none");
        this.searchMessage.innerHTML = message;
    }
    renderError() {
        this.spinnerCon.classList.add("d-none");
        // this.searchMessage.classList.remove("d-none");
        this.renderMessage(this.errorMessage);
    }
    addHandlerKeyPress(handler) {
        if (!this.searchInput) return;
        this.searchInput.addEventListener("keyup", (function(e) {
            // if user dont pressed exclude keys then render
            if (!this.excludeKeys.includes(e.key)) {
                this.clear();
                this.searchMessage.classList.add("d-none");
                handler(this.searchInput.value);
            }
        }).bind(this));
    }
    // for prevent form submit when user press enter
    addHandlerSubmit() {
        this.parentEl.querySelector("form").addEventListener("submit", function(e) {
            e.preventDefault();
        });
    }
}
var $7444704d607188f2$export$2e2bcd8739ae039 = new $7444704d607188f2$var$search();


const $d583ed96691ecef0$var$timeout = function(s) {
    return new Promise(function(_, reject) {
        setTimeout(function() {
            reject(new Error(`Request took too long! Timeout after ${s} second`));
        }, s * 1000);
    });
};
const $d583ed96691ecef0$export$a75c676177490cac = async function(url) {
    try {
        const res = await Promise.race([
            fetch(url),
            $d583ed96691ecef0$var$timeout(10)
        ]);
        const data = await res.json();
        // console.log(`data from helper: ${data}`);
        if (!res.ok) throw new Error(`${data.message} (${res.status})`);
        return data;
    } catch (err) {
        throw err;
    }
};


const $1e3c1a6f09508bd8$export$5776aaa54ac48dcc = `${window.location.origin}/wp-json/newsbx/v1/search?term=`;


// prettier-ignore
const $5b5aee277ffc30d3$var$convertor = {
    0: "\u06F0",
    1: "\u06F1",
    2: "\u06F2",
    3: "\u06F3",
    4: "\u06F4",
    5: "\u06F5",
    6: "\u06F6",
    7: "\u06F7",
    8: "\u06F8",
    9: "\u06F9"
};
const $5b5aee277ffc30d3$var$convertorKeys = Object.keys($5b5aee277ffc30d3$var$convertor);
const $5b5aee277ffc30d3$export$ca000e230c0caa3e = {
    searcResults: []
};
const $5b5aee277ffc30d3$export$202b8e5cb363a0c4 = async function(userInput) {
    try {
        // 1) fetching data
        const data = await (0, $d583ed96691ecef0$export$a75c676177490cac)(`${(0, $1e3c1a6f09508bd8$export$5776aaa54ac48dcc)}${userInput}`);
        // 2) turns english numbers to farsi
        const matchWord = [
            ...userInput
        ].map((l)=>$5b5aee277ffc30d3$var$convertorKeys.includes(l) ? $5b5aee277ffc30d3$var$convertor[l] : l).join("");
        console.log(matchWord);
        // 3) filter all results with userinput
        $5b5aee277ffc30d3$export$ca000e230c0caa3e.searcResults = data.filter((post)=>post.title.includes(matchWord));
    } catch (err) {
        throw err;
    }
};


class $fd4544f0441d9c73$var$morePriceBtn {
    items = document.querySelectorAll(".coll-item");
    constructor(){
        this.btnToggler();
    }
    btnToggler() {
        window.addEventListener("click", (function(e) {
            const btn = e.target.closest(".tgBtn");
            if (!btn) return;
            this.items.forEach((item)=>{
                item.classList.toggle("d-none");
            });
            btn.querySelectorAll("h6").forEach((el)=>{
                el.classList.toggle("d-none");
            });
        }).bind(this));
    }
}
var $fd4544f0441d9c73$export$2e2bcd8739ae039 = new $fd4544f0441d9c73$var$morePriceBtn();


// ++++++++++++++++++++++++++++++++  feature slider  +++++++++++++++++++++++++++++
const $f953655b7784ad48$var$controlSlider = function(goToSlide) {
    (0, $b936f479e4f933e2$export$2e2bcd8739ae039).changeActiveCircle(goToSlide);
    clearInterval((0, $b936f479e4f933e2$export$2e2bcd8739ae039).interval);
};
const $f953655b7784ad48$var$controlSearchLoad = async function(userInput) {
    try {
        // spinner
        (0, $7444704d607188f2$export$2e2bcd8739ae039).renderSpinner();
        // load search results
        await $5b5aee277ffc30d3$export$202b8e5cb363a0c4(userInput);
        // render search results
        setTimeout(()=>{
            // console.log(model.state.searcResults);
            (0, $7444704d607188f2$export$2e2bcd8739ae039).render($5b5aee277ffc30d3$export$ca000e230c0caa3e.searcResults);
        }, 2000);
    } catch (err) {
        (0, $7444704d607188f2$export$2e2bcd8739ae039).renderError();
    }
};
const $f953655b7784ad48$var$init = function() {
    // manuall slide changer
    (0, $b936f479e4f933e2$export$2e2bcd8739ae039).addHandlerManualSlider($f953655b7784ad48$var$controlSlider);
    // Auto slide changer
    (0, $b936f479e4f933e2$export$2e2bcd8739ae039).addHandlerAutoSlider();
    // search
    (0, $7444704d607188f2$export$2e2bcd8739ae039).addHandlerKeyPress($f953655b7784ad48$var$controlSearchLoad);
};
$f953655b7784ad48$var$init();

})();
//# sourceMappingURL=controller.js.map
